import React from 'react';
import { Dialog, DialogTitle, DialogContent, Box, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

type DialogueModalDaiProps = {
  width?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  isOpen: boolean;
  title: string;
  handleClose: (e?: any) => void;
  isShowCloseButton?: boolean;
  children?: React.ReactNode;
  headerContent?: React.ReactNode;
  dialogContentProps?: React.ComponentProps<typeof DialogContent>;
  className?: string;
  titleSx?: Record<string, any>;
  PaperProps?: Record<string, any>;
}

const DialogueModalDai: React.FC<DialogueModalDaiProps> = ({
  isOpen,
  title,
  handleClose,
  isShowCloseButton = true,
  width,
  children,
  headerContent,
  dialogContentProps,
  className,
  titleSx,
  PaperProps
}) => {
  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      fullWidth
      maxWidth={width || "sm"}
      className={className}
      PaperProps={PaperProps}
      sx={{
        margin: '0 30px 0 25px'
      }}
    >
      <DialogTitle
        sx={{
          bgcolor: 'primary.main',
          color: 'white.main',
          p: 1,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          ...titleSx,
        }}
      >
        <Typography variant='widgetTitle'>{title}</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {headerContent}
          {isShowCloseButton && (
            <IconButton
              onClick={handleClose}
              sx={{
                color: 'white.main',
              }}
            >
              <CloseIcon />
            </IconButton>
          )}
        </Box>
      </DialogTitle>

      <DialogContent sx={{ p: 0 }}>
        <Box sx={{ textAlign: 'center' }} {...dialogContentProps}>
          {children}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default DialogueModalDai;
